import React, { useState, useRef } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Box, Typography
} from '@mui/material';

export default function ThumbnailUploadModal({
  open,
  onClose,
  onUpload,
  item,
  currentPath,
  setRefresh,
  setThumbnailLoading
}) {
  const [preview, setPreview] = useState(null);
  const [file, setFile] = useState(null);
  const inputRef = useRef();

  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    if (selected) {
      setFile(selected);
      const previewUrl = URL.createObjectURL(selected);
      setPreview(previewUrl);
    }
  };

  const handleUpload = () => {
    if (file) {
      onUpload(item, file, currentPath, setRefresh, setThumbnailLoading);
      onClose();
      setPreview(null);
      setFile(null);
    }
  };

  const handleClose = () => {
    setPreview(null);
    setFile(null);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>Upload Thumbnail</DialogTitle>
      <DialogContent>
        <Button
          variant="outlined"
          onClick={() => inputRef.current.click()}
          fullWidth
        >
          Choose Image
        </Button>
        <input
          type="file"
          accept="image/*"
          ref={inputRef}
          onChange={handleFileChange}
          style={{ display: 'none' }}
        />

        {preview && (
          <Box mt={2} textAlign="center">
            <Typography variant="body2" gutterBottom>
              Preview:
            </Typography>
            <Box
              component="img"
              src={preview}
              alt="Thumbnail Preview"
              sx={{ width: '100%', borderRadius: 2 }}
            />
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleUpload} variant="contained" disabled={!file}>
          Upload
        </Button>
      </DialogActions>
    </Dialog>
  );
}
